import { createColumnHelper } from '@tanstack/react-table';
import { L } from 'harmony-language';
import { useMemo } from 'react';
import { Formula } from '../../../types';

export const useFormulaColumns = () => {
    const columnHelper = createColumnHelper<Formula>();

    const columns = useMemo(() => ([
        columnHelper.accessor('name', {
            header: L.name(),
            cell: (info) => info.getValue(),
            enableColumnFilter: false,
        }),
    ]), []);

    return columns;
}
